import(/* webpackMode: "eager" */ "/app/app/[locale]/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/common/links/PhoneLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/common/WhatsappWidget.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/layout/FooterLogo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/navigation/Navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/navigation/NavLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/providers/Providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UTMCaptureClient"] */ "/app/components/UTMCaptureClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SettingsProvider"] */ "/app/contexts/SettingsContext.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"app/[locale]/fonts.ts\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-inter\",\"display\":\"swap\",\"preload\":true,\"fallback\":[\"-apple-system\",\"BlinkMacSystemFont\",\"Segoe UI\",\"Roboto\",\"system-ui\",\"sans-serif\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"app/[locale]/fonts.ts\",\"import\":\"Urbanist\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-urbanist\",\"display\":\"swap\",\"preload\":true,\"fallback\":[\"-apple-system\",\"BlinkMacSystemFont\",\"Segoe UI\",\"Roboto\",\"system-ui\",\"sans-serif\"]}],\"variableName\":\"urbanist\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"app/[locale]/fonts.ts\",\"import\":\"Tajawal\",\"arguments\":[{\"subsets\":[\"arabic\",\"latin\"],\"weight\":[\"400\",\"500\",\"700\"],\"variable\":\"--font-inter\",\"display\":\"swap\",\"preload\":false,\"fallback\":[\"Arial\",\"sans-serif\"]}],\"variableName\":\"tajawal\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"app/[locale]/fonts.ts\",\"import\":\"Cairo\",\"arguments\":[{\"subsets\":[\"arabic\",\"latin\"],\"variable\":\"--font-urbanist\",\"display\":\"swap\",\"preload\":false,\"fallback\":[\"Arial\",\"sans-serif\"]}],\"variableName\":\"cairo\"}");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/node_modules/sonner/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/public/assets/images/homes-logo.png");
;
import(/* webpackMode: "eager" */ "/app/public/assets/images/innovation-logo.png");
;
import(/* webpackMode: "eager" */ "/app/public/assets/images/jobs-logo.png");
;
import(/* webpackMode: "eager" */ "/app/public/assets/images/ravo-logo.png");
;
import(/* webpackMode: "eager" */ "/app/public/assets/images/white-ar-logo.webp");
;
import(/* webpackMode: "eager" */ "/app/public/assets/images/white-logo.png");
